// extracted by mini-css-extract-plugin
export default {"mCard":"hE-z","image":"iE-z","imageNoBackground":"jE-z","imageHasCategory":"kE-z","fullWidth":"lE-z"};